import { atom } from "recoil";

export const hidePanelState = atom({
  key: "hidePanelState",
  default: true,
});

export const menuDrawerState = atom({
  key: "menuDrawerState",
  default: false,
});

export const searchOptionsState = atom({
  key: "searchOptionsState",
  default: [],
});

export const anchorElState = atom({
  key: "anchorElState",
  default: null,
});

export const inputEventState = atom({
  key: "inputEventState",
  default: [{}],
});
export const variablesState = atom({
  key: "variablesState",
  default: {},
});

export const picsState = atom({
  key: "picsState",
  default: [],
});

export const notificationDetailSortedState = atom({
  key: "notificationDetailSortedState",
  default: [],
});

export const visionNotificationDetailSortedState = atom({
  key: "visionNotificationDetailSortedState",
  default: [],
});

export const bellNotificationDetailSortedState = atom({
  key: "bellNotificationDetailSortedState",
  default: [],
});

export const allNotificationDataState = atom({
  key: "allNotificationDataState",
  default: [],
});

export const nextTokenState = atom({
  key: "nextTokenState",
  default: {},
});

export const unReadCountState = atom({
  key: "unReadCountState",
  default: {},
});

export const userListState = atom({
  key: "userListState",
  default: [],
});

export const loadingState = atom({
  key: "loadingState",
  default: false,
});

export const badgeDetailState = atom({
  key: "badgeDetailState",
  default: {
    userId: "",
    comment: "",
    badge: "",
  },
});

export const errorBadgeDetailsState = atom({
  key: "errorBadgeDetailState",
  default: {
    userId: "",
    comment: "",
    badge: "",
  },
});
